<template>
  <div class="jo-custom" :id="childTabId">
    <h3>{{childTabId}}</h3>
  </div>
</template>
<script>
  export default {

    data() {
      return {

      }
    },
    props: {
      childTabId: String,
      required: true
    }
  }
</script>

<style lang="scss" scoped>
  .jo-custom {
    background-color: #fafafa;
    position: relative;
    padding: 10px 10px 0 20px;
    h3 {
      font-size: 1.8rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/customTab/customTab.vue